module.exports = __webpack_public_path__ + "img/view-bird-animation-1.8e5777bb.png";